namespace Matrix.Workflow {
    export class TaskColumns {
        static columnsKey = 'Workflow.Task';
    }
}
